export default __webpack_public_path__ + "static/media/empty-notes.5960495b.svg";